<ng-container *ngIf="!componentType">
    <div *ngIf="requestStatusType === requestStatusTypes.REJECTED" class="status-message rejected">
        <div class="col-one">
            <div class="status-icon">
                <i class="icon-status-reject"></i>
            </div>
            <div class="status-text">
                <div class="status-title" *ngIf="title">{{title | translate}}!</div>
                <div class="status-title" *ngIf="!title">{{'ENUM.REQUEST_STATUS.REJECTED' | translate}}!</div>
                <div class="status-explain" *ngIf="text"> {{ text | translate}} </div>
                <div class="status-explain" *ngIf="!text"> {{ 'REQUEST.ALERT.REJECTED_TEXT' | translate}} </div>
            </div>

        </div>

    </div>

    <div class="status-message delete" *ngIf="requestStatusType === requestStatusTypes.DELETED">
        <div class="col-one">
            <div class="status-icon">
                <i class="icon-status-delete"></i>
            </div>
            <div class="status-text">
                <div class="status-title">{{'ENUM.REQUEST_STATUS.DELETED' | translate}}!</div>
                <div class="status-explain"> {{ text | translate}} </div>
            </div>
        </div>
    </div>

    <div class="status-message refund" *ngIf="requestStatusType === requestStatusTypes.REFUND">
        <div class="col-one">
            <div class="status-icon">
                <i class="icon-status-refund"></i>
            </div>
            <div class="status-text">
                <div class="status-title">{{'ENUM.REQUEST_STATUS.REFUND' | translate}}!</div>
                <div class="status-explain"> {{ text | translate}} </div>
            </div>
        </div>


    </div>

    <div class="status-message done" *ngIf="requestStatusType === requestStatusTypes.DONE">
        <div class="col-one">
            <div class="status-icon">
                <i class="icon-status-done"></i>
            </div>
            <div class="status-text">
                <div class="status-title">{{'ENUM.REQUEST_STATUS.DONE' | translate}}!</div>
                <div class="status-explain"> {{ text | translate}} </div>
            </div>
        </div>


    </div>

    <div class="status-message waiting" *ngIf="isWating">
        <div class="status-text">
            <div class="status-title">{{'GENERAL.WAITING' | translate}}!</div>
            <div class="status-explain" *ngIf="!text"> {{ 'REQUEST.ALERT.PROCESSING_TEXT' | translate}} </div>
            <div class="status-explain" *ngIf="text"> {{ text | translate}} </div>
            <div class="status-explain2" *ngIf="text2"> {{ text2 | translate}} </div>

        </div>
        <div class="status-image" *ngIf="!removeIcon">
            <img src="assets/media/images/status/support.png">
        </div>
    </div>


    <!-- <div class="status-message payment" *ngIf="requestStatusType ===requestStatusTypes.PAYMENT">
    <div class="status-text">
        <div class="status-title">{{'REQUEST.PAYMENT.PAYMENT' | translate}}!</div>
        <div class="status-explain" *ngIf="text"> {{ text | translate}} </div>
        <div class="status-explain" *ngIf="!text"> {{ 'REQUEST.ALERT.PAYMENT_TEXT' | translate}} </div>
    </div>
    <div class="status-image">
        <img src="assets/media/images/status/support.png">
    </div>
</div> -->
</ng-container>

<!--Accounts-->
<ng-container *ngIf="componentType === componentTypes.Accounts">
    <!--Regected-->
    <div *ngIf="accountStatusType === accountStatus.Rejected" class="status-message rejected">
        <div class="col-one">
            <div class="status-icon">
                <i class="icon-status-reject"></i>
            </div>
            <div class="status-text">
                <div class="status-title">{{'GENERAL.REJECTED' | translate}}!</div>
                <div class="status-explain" *ngIf="text"> {{ text | translate}} </div>
                <div class="status-explain" *ngIf="!text"> {{ 'REQUEST.ALERT.REJECTED_TEXT' | translate}} </div>
            </div>
        </div>
    </div>

    <!--Pending-->
    <div *ngIf="accountStatusType === accountStatus.New" class="status-message waiting">
        <div class="status-text">
            <div class="status-title">{{'GENERAL.WAITING' | translate}}!</div>
            <div class="status-explain" *ngIf="!text"> {{ 'REQUEST.ALERT.PROCESSING_TEXT' | translate}} </div>
            <div class="status-explain" *ngIf="text"> {{ text | translate}} </div>
        </div>
        <div class="status-image">
            <img src="assets/media/images/status/support.png">
        </div>
    </div>

    <!--ACCEPTED-->
    <div *ngIf="accountStatusType === accountStatus.Accepted" class="status-message done">
        <div class="status-text">
            <div class="status-title">{{'GENERAL.DONE' | translate}}!</div>
            <div class="status-explain"> {{ text | translate}} </div>
        </div>
        <div class="status-icon">
            <i class="icon-status-done"></i>
        </div>
    </div>


</ng-container>